import React, { useState, useEffect, useRef } from 'react';
import Nav from './Nav';
import List from './List';
import ContentBlock from './ContentBlock';
import ImagesBlock from './ImagesBlock';
import { ContentBox, FlexItemContent, MainGrid } from '../styles/GridStyle';

export default function Grid({ pageContent, location }) {
  const [isBig, setIsBig] = useState(false);
  // const [showNav, setShowNav] = useState(false);
  const [isHover, setIsHover] = useState(false);
  const [isHoverQuery, setIsisHoverQuery] = useState({});
  const imageRef = useRef(null);

  const dataToInsert = pageContent.props.data;
  const urlPath = pageContent.props.uri;

  const checkPagesList =
    urlPath === '/realisations' ||
    urlPath === '/etudes' ||
    urlPath === '/actualites' ||
    urlPath === '/infos';

  useEffect(() => {
    setIsBig(false);

    if (isHover !== '') {
      if (
        dataToInsert &&
        !/infos/.test(urlPath) &&
        !/biographie/.test(urlPath) &&
        !/cv/.test(urlPath) &&
        !/colophon/.test(urlPath) &&
        !/contact/.test(urlPath)
      ) {
        const arrayElem = dataToInsert.queryPage.nodes.filter(
          (elem) => elem.slug.current === isHover
        );

        setIsisHoverQuery(arrayElem[0]);
      }
    }

    return () => {};
  }, [location, isHover]);

  return (
    <MainGrid>
      <FlexItemContent
        ref={imageRef}
        isBig={isBig}
        bigWidth="100%"
        className="imgsPart"
      >
        <Nav urlPath={location} img />

        {dataToInsert && (
          <ContentBox isBig={isBig}>
            {/* {pageContent} */}
            <List
              img
              titlesList={dataToInsert.queryPage.nodes}
              urlPath={urlPath}
              isBig={isBig}
              setIsHover={setIsHover}
            />

            {!checkPagesList &&
              (isHoverQuery ? (
                <ImagesBlock
                  setIsBig={setIsBig}
                  isBig={isBig}
                  pageData={isHoverQuery}
                />
              ) : (
                <ImagesBlock
                  setIsBig={setIsBig}
                  isBig={isBig}
                  pageData={dataToInsert}
                />
              ))}

            {checkPagesList &&
              (isHoverQuery ? (
                <ImagesBlock
                  setIsBig={setIsBig}
                  isBig={isBig}
                  pageData={isHoverQuery}
                />
              ) : (
                ''
              ))}
          </ContentBox>
        )}
      </FlexItemContent>

      <FlexItemContent isBig={isBig} bigWidth={0} className="textPart">
        <Nav urlPath={urlPath} isBig={isBig} />

        {dataToInsert && (
          <ContentBox>
            <List
              titlesList={dataToInsert.queryPage.nodes}
              img={false}
              urlPath={urlPath}
              isBig={isBig}
              setIsHover={setIsHover}
            />

            {!checkPagesList &&
              (isHoverQuery ? (
                <ContentBlock pageData={isHoverQuery} />
              ) : (
                <ContentBlock pageData={dataToInsert} />
              ))}

            {checkPagesList &&
              (isHoverQuery ? <ContentBlock pageData={isHoverQuery} /> : '')}
          </ContentBox>
        )}
      </FlexItemContent>
    </MainGrid>
  );
}
